import { useMutation } from '@tanstack/react-query';
import { patchInformationById } from '../../../../api/information/mutations/patchInformationById';

export const usePatchInformationByIdMutation = () => {
  return useMutation(patchInformationById);
};
